export const PENDING_CHANGES_AUTHORS_HEADER = 'X-Skynet-Pending-Changes-Authors';

export const PendingChangesAuthorsHeaderToken = {
  AI: 'ai',
  NONE: 'none',
};

export const AI_PENDING_CHANGES_AUTHOR_KEY = PendingChangesAuthorsHeaderToken.AI;

export const AI_ASSISTANT_AUTHOR_NAME = 'AI Assistant';

export const CURRENT_USER_AUTHOR_LABEL = 'Me';

export const AI_AUTO_INITIATED_LABEL = 'Auto-initiated';

export const AI_STARTED_BY_PREFIX = 'started by';

export const AiActorTypeName = {
  AI_PROCESS: 'AiProcess',
  HUMAN: 'Human',
};

// Trigger sources where a person deliberately ran the AI process; every other source is automated.
export const AI_USER_STARTED_TRIGGER_SOURCES = ['manual', 'loanaction'];

// The changes-history read must always list every author's pending changes, so the selection header
// is never applied to it.
export const PENDING_CHANGES_AUTHORS_HEADER_EXCLUDED_URL_PARTS = ['/changes/history'];

export const OTHERS_SAVE_PERMISSION_DENIED_MESSAGE =
  'You can view these changes but do not have permission to save them.';
